import React, { useState, useEffect, useRef } from 'react'
import posed, { PoseGroup } from 'react-pose'
import Icon from '../utils/Icon'
import Button from '../utils/Button'
import ConfirmBox from '../utils/ConfirmBox'
import BingStaticMap from '../utils/BingStaticMap'
import CONFIG from '../../config'

const PosedArrow = posed.div({
  start: { opacity: 0 },
  end: {
    opacity: 1,
    transition: {
      delay: 300,
      duration: 500,
      ease: 'easeOut',
    },
  },
})
const PosedCircle = posed.div({
  start: {
    borderRadius: '0%',
    transformOrigin: 'bottom right',
    scale: 2,
  },
  end: {
    borderRadius: '100%',
    scale: 1,
    transformOrigin: 'bottom right',
    transition: {
      duration: 300,
      ease: 'easeOut',
    },
  },
})
const PosedConfirmBox = posed.div({})

const StoreDetails = ({ data, onClose }) => {
  const {
    name,
    storeName,
    address: { addressLine1, city, postcode },
    telephone,
    location,
  } = data

  const mapWrapperRef = useRef(null)
  const [showMap, setShowMap] = useState(false)
  const [mapSize, setMapSize] = useState()
  const [showConfirmBox, setShowConfirmBox] = useState(false)

  useEffect(() => {
    let height = mapWrapperRef.current.offsetHeight
    let width = mapWrapperRef.current.offsetWidth
    setMapSize({
      height,
      width,
    })
    setShowMap(true)
  }, [])

  function handleOpenMap() {
    setShowConfirmBox(true)
  }

  function handleConfirmation(confirm) {
    const {
      location: { latitude, longitude },
    } = data
    switch (confirm) {
      case 'yes':
        setShowConfirmBox(false)
        window.open(
          `http://www.google.com/maps/place/${latitude},${longitude}/@${latitude},${longitude},16z`,
          '_blank'
        )
        break
      case 'no':
        setShowConfirmBox(false)
        break
      default:
        break
    }
  }

  return (
    <div
      data-cy="store-details"
      className="z-20 flex flex-col w-full h-screen overflow-hidden bg-white rounded-l-modal"
    >
      <div className="relative flex-1 w-full mb-8" ref={mapWrapperRef}>
        {showMap && (
          <>
            <BingStaticMap
              bingmapKey={CONFIG.BING_MAP_KEY}
              location={location}
              mapSize={mapSize}
            />
            {!showConfirmBox && (
              <PosedCircle
                key="posed-circle"
                initialPose="start"
                pose="end"
                className={`absolute bottom-0 right-0 mr-8 -mb-5 w-12 h-12 flex justify-center items-center 
                text-white cursor-pointer bg-secondary`}
                onClick={handleOpenMap}
              >
                <PosedArrow
                  key="posed-arrow"
                  initialPose="start"
                  pose="end"
                  className="flex justify-center"
                >
                  <Icon
                    icon="navigation"
                    className="relative w-1/2 fill-current"
                  />
                </PosedArrow>
              </PosedCircle>
            )}
            <PoseGroup>
              <PosedConfirmBox
                key="posed-confirm-box"
                initialPose="start"
                pose="end"
                className="absolute bottom-0 right-0 max-w-4xl mr-8 -mb-5"
              >
                {showConfirmBox && [
                  <ConfirmBox
                    key="confirm-box"
                    onConfirmation={handleConfirmation}
                  />,
                ]}
              </PosedConfirmBox>
            </PoseGroup>
          </>
        )}
      </div>
      <div className="flex-1 px-6 text-lg font-medium">
        <div data-cy="store-address" className="text-2xl font-semibold">
          {storeName}
        </div>
        <div data-cy="store-address">{addressLine1}</div>
        <div
          data-cy="store-address"
          className="mb-6"
        >{`${city} ${postcode}`}</div>
        <div data-cy="store-address" className="font-semibold">
          Telephone
        </div>
        <a
          href={`tel:${telephone}`}
          data-cy="store-address"
          className="block mb-6 underline text-body"
        >
          {telephone}
        </a>
        <a
          className="flex items-center block mb-6 font-medium underline text-secondary"
          href={`https://my.morrisons.com/storefinder/${name}`}
          target="_blank"
          rel="noopener noreferrer"
          data-cy="store-link"
        >
          <span className="block mr-2">Store details on store finder</span>
          <Icon icon="external" className="w-3 h-3" />
        </a>
      </div>
      <div className="px-6 mb-8">
        <Button variant="outlined" onClick={onClose}>
          <span className="flex items-center justify-center block w-full pl-2">
            <Icon icon="back" />
            <span className="block px-2">Back to home screen</span>
          </span>
        </Button>
      </div>
    </div>
  )
}

export default StoreDetails
